export default __webpack_public_path__ + "static/media/governor-plain.4f1f798d.png";